export const MobileIcon = ({ className }: { className?: string }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.4494 3.33203V15.832H14.5512V3.33203H6.4494ZM7.0281 0.832031H13.9725C15.1444 0.832031 15.7086 1.64971 15.7086 2.91536V17.082C15.7086 18.3477 15.1444 19.1654 13.9725 19.1654H7.0281C5.8562 19.1654 5.29199 18.3477 5.29199 17.082V2.91536C5.29199 1.64971 5.8562 0.832031 7.0281 0.832031Z"
      fill="currentColor"
    />
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.33301 3.33203V15.832H14.6663V3.33203H6.33301Z"
      fill="currentColor"
    />
    <path
      d="M10.5003 18.3346C10.9606 18.3346 11.3337 17.9615 11.3337 17.5013C11.3337 17.0411 10.9606 16.668 10.5003 16.668C10.0401 16.668 9.66699 17.0411 9.66699 17.5013C9.66699 17.9615 10.0401 18.3346 10.5003 18.3346Z"
      fill="currentColor"
    />
  </svg>
);
